<template>
    <div class="animated fadeIn">
        <b-tabs>
            <b-tab v-if="Core.Validation.isId(dataId)">
                <template slot="title">
                    <i class="fa fa-list mr-2"></i>{{Core.Definition.getDefinition('Structure')}}
                </template>
                <FormTemplateStructure v-model="dataId"></FormTemplateStructure>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <i class="fa fa-cogs mr-2"></i>{{Core.Definition.getDefinition('Paramètres')}}
                </template>
                <DynamicForm
                        v-model="dataId"
                        ref="dynamicForm"
                        getRoot="/form-template"
                        saveRoot="/form-template"
                        @onSave="onSave"
                        :formStructure="dataFormStructures.form">
                </DynamicForm>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import DynamicForm from '../../components/DynamicForm'
    import FormTemplateStructure from './FormTemplateStructure'
    export default {
        name: 'ContractTemplate',
        components: {
            DynamicForm,
            FormTemplateStructure
        },
        mounted() {

        },
        data: function () {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataId: '',
                dataFormStructures: {
                    form: {
                        rows: [
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'title'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'description'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'title',
                                type: 'text',
                                label: Core.Definition.getDefinition('Titre'),
                                value: ''
                            },
                            {
                                id: 'description',
                                type: 'editor',
                                label: Core.Definition.getDefinition('Description'),
                                value: ''
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onSave() {
                this.$refs.dynamicForm.addSaveArg('instance', Mantle.FormTemplate.instanceContract)
            }
        }
    }
</script>
